import { h } from "@/lib/dom";
import { emptyState, button } from "@/components/ui";
import { navigate } from "@/app/router";

export function NotFoundPage(): HTMLElement {
  return h(
    "div",
    { class: "card card-pad mt-2" },
    emptyState({
      icon: "search",
      title: "Seite nicht gefunden",
      text: "Diese Seite gibt es nicht.",
      action: button({
        label: "Zur Startseite",
        icon: "home",
        variant: "primary",
        onClick: () => navigate("/"),
      }),
    })
  );
}
